document.addEventListener("DOMContentLoaded", () => {
  const $slider = $('.homepage-hero-b-ctas');

  $slider.slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    customPaging: function(slider, i) {
      return $('<button>');
    },
    arrows: false,
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 700,  settings: { slidesToShow: 2, slidesToScroll: 1, dots: true } },
      { breakpoint: 400,  settings: { slidesToShow: 1.2, slidesToScroll: 1, dots: true } },
    ],
  });

  $('.homepage-hero-b-ctas').height('auto');
});
